import { Theme } from '@mui/material/styles'

const muiAvatar = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        fontSize: '1.375rem'
      },
      square: {
        borderRadius: 0
      },
      rounded: {
        borderRadius: '30%'
      }
    }
  }
}

export default muiAvatar
